import { Component } from '@angular/core';

@Component({
    selector: 'regimen',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class RegimenComponent {}
